// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.select__input {
  color: transparent;
}

.text-underline {
  text-decoration: underline;
}

.utils-screen-all .utils-discord {
  background: var(--black1);
  padding: 1rem;
  border-radius: 0.25rem;
  margin-top: 1rem;
}
.utils-screen-all .utils-discord .paylixecommerce-select {
  background-color: var(--white);
}
.utils-screen-all .utils-discord .switcher input:checked + .switcher-slider {
  background-color: var(--purple6);
}
.utils-screen-all .utils-discord .switcher input:checked + .switcher-slider::before {
  background-color: var(--white);
}
.utils-screen-all .utils-discord .switcher .switcher-slider {
  background-color: var(--white);
}
.utils-screen-all .utils-discord .switcher .switcher-slider:before {
  background-color: var(--black1);
}

.dark .utils-screen-all .utils-discord .paylixecommerce-select {
  background-color: var(--white);
}
.dark .utils-screen-all .utils-discord .switcher input:checked + .switcher-slider {
  background-color: var(--purple6);
}
.dark .utils-screen-all .utils-discord .switcher input:checked + .switcher-slider::before {
  background-color: var(--black9) !important;
}
.dark .utils-screen-all .utils-discord .switcher .switcher-slider {
  background-color: var(--black3);
}
.dark .utils-screen-all .utils-discord .switcher .switcher-slider:before {
  background-color: var(--black1);
}`, "",{"version":3,"sources":["webpack://./client/entrypoints/dashboard/screens/products/product/screens/components/discord/index.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;AACJ;;AAEA;EACI,0BAAA;AACJ;;AAGG;EACI,yBAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;AAAP;AAEO;EACI,8BAAA;AAAX;AAIW;EACI,gCAAA;AAFf;AAIe;EACI,8BAAA;AAFnB;AAMW;EACI,8BAAA;AAJf;AAMe;EACI,+BAAA;AAJnB;;AAaQ;EACI,8BAAA;AAVZ;AAcY;EACI,gCAAA;AAZhB;AAcgB;EACI,0CAAA;AAZpB;AAgBY;EACI,+BAAA;AAdhB;AAgBgB;EACI,+BAAA;AAdpB","sourcesContent":[".select__input {\n    color: transparent;\n}\n\n.text-underline {\n    text-decoration: underline;\n}\n\n.utils-screen-all {\n   .utils-discord {\n       background: var(--black1);\n       padding: 1rem;\n       border-radius: .25rem;\n       margin-top: 1rem;\n\n       .paylixecommerce-select {\n           background-color: var(--white);\n       }\n\n       .switcher {\n           input:checked + .switcher-slider {\n               background-color: var(--purple6);\n\n               &::before {\n                   background-color: var(--white);\n               }\n           }\n\n           .switcher-slider {\n               background-color: var(--white);\n\n               &:before {\n                   background-color: var(--black1);\n               }\n           }\n       }\n   }\n}\n\n.dark .utils-screen-all {\n    .utils-discord {\n        .paylixecommerce-select {\n            background-color: var(--white);\n        }\n\n        .switcher {\n            input:checked + .switcher-slider {\n                background-color: var(--purple6);\n\n                &::before {\n                    background-color: var(--black9) !important;\n                }\n            }\n\n            .switcher-slider {\n                background-color: var(--black3);\n\n                &:before {\n                    background-color: var(--black1);\n                }\n            }\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
